import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Checkbox,
  RadioButton,
  TextArea,
  TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";
import { useEffect, useState } from "react";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Whisper, Tooltip } from "rsuite";
import { AnswerOption, Question } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "../confirm";
import { useIntl } from "react-intl";

export interface OptionsProps {
  radioOrCheckBox: boolean;
  makeBig: boolean;
  answerOption: AnswerOption;
  lastQuestion: boolean;
  questionId: string;
  handleCorrectOption: (e: string) => void;
  handleUpdateOptionValue: (optionId: string, optionValue: string) => void;
  anyOptionSelect?: boolean;
}

export function Options(props: OptionsProps) {
  const intl = useIntl();
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [option, setOption] = useState<string>(
    props.answerOption.optionVal as string
  );
  console.log("option value print", option);
  const tooltip = (
    <Tooltip className="bg-mk-primary-bright">
      <div className="font-bold text-sm">{props.answerOption.optionFlag}</div>
      <div>{props.answerOption.optionRationale}</div>
    </Tooltip>
  );

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleUpdateOptionValueChange = (e: TextAreaChangeEvent) => {
    console.log("entered update option value");
    props.handleUpdateOptionValue(
      props.answerOption.optionId,
      e.value!!.toString()
    );
    setIsEditing(true);
    setOption(e.value!!.toString());
  };

  return (
    <div className="px-2 w-72 flex flex-row space-x-1 items-center">
      {props.radioOrCheckBox ? (
        <RadioButton
          defaultChecked={
            props.answerOption.optionFlag === "CORRECT" ? true : false
          }
          disabled={!props.makeBig}
          name={props.questionId}
          onChange={() => {
            props.handleCorrectOption(props.answerOption.optionId);
          }}
        />
      ) : (
        <Checkbox
          defaultChecked={props.answerOption.optionFlag === "CORRECT"}
          disabled={!props.makeBig}
          name={props.questionId}
          onChange={() => {}}
        />
      )}

      <TextArea
        value={option}
        onChange={(e: TextAreaChangeEvent) => handleUpdateOptionValueChange(e)}
        placeholder={intl.formatMessage({ id: "optionPlaceholder" })}
        onBlur={handleBlur}
        autoSize={true}
        rows={1}
        maxLength={60}
        onFocus={() => setIsEditing(true)}
        className={
          props.makeBig
            ? `editable-assessment-div text-sm w-full ${
                isEditing ? "bg-white" : "bg-transparent border-transparent"
              }`
            : "editable-assessment-div text-sm w-full"
        }
      />

      <Whisper
        placement={props.lastQuestion ? "left" : "right"}
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <FontAwesomeIcon
          icon={["far", "fa-circle-info" as IconName]}
          className="h-3.5 w-3.5 text-mk-primary-bright hover:cursor-pointer"
        />
      </Whisper>
    </div>
  );
}

export interface AssementCardProps {
  showCardMenuBar: boolean;
  question: Question;
  lastQuestion: boolean;
  index: number;
  maxCards: number;
  key: number;
  updateQuestion?: (e: Question) => void;
  deleteQuestion?: (e: string) => void;
}

export function AssementCard(props: AssementCardProps) {
  const intl = useIntl();
  const [radioOrCheckBox, setRadioOrCheckBox] = useState<boolean>(true);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [questionDetail, setQuestionDetail] = useState<Question>(
    props.question
  );
  const [wantToDelete, setWantToDelete] = useState<boolean>(false);
  const [question, setQuestion] = useState<string>(
    props.question.question as string
  );
  const [optionState, setOptionState] = useState<any>(
    questionDetail.answerOptions
  );
  const [anyOptionSelect, setAnyOptionSelect] = useState<boolean>(false);

  const isAnyOptionSelected = optionState!!.some(
    (option: any) => option.optionFlag === "CORRECT"
  );
  console.log("is any option selected", isAnyOptionSelected);
  console.log("use state for any option select", anyOptionSelect);

  // console.log("Card no. in assessment",props.index(props.question.quesId))
  console.log("Card no. in assessment", props.key);
  console.log("max cards in assessment", props.maxCards);

  console.log("question detail print", questionDetail);
  console.log("question detail bg color", questionDetail.bgColor);
  console.log(
    "question detail answer options print",
    questionDetail.answerOptions
  );

  const handleCorrectOption = (e: string) => {
    console.log("enter handle correct option val in assessment", e);

    let allQuestions = questionDetail;
    allQuestions.answerOptions.map((ele, i) => {
      if (ele.optionId === e) {
        ele.optionFlag = "CORRECT";
      } else {
        ele.optionFlag = "INCORRECT";
      }
      return ele;
    });

    setQuestionDetail(allQuestions);
    setAnyOptionSelect(isAnyOptionSelected);

    if (props.updateQuestion) {
      props.updateQuestion(allQuestions);
    }
  };

  const handleUpdateOptionValue = (optionId: string, optionValue: string) => {
    console.log("update option val entered", optionId, optionValue);
    let allQuestions = questionDetail;
    allQuestions.answerOptions.map((ele, i) => {
      if (ele.optionId == optionId) {
        ele.optionVal = optionValue;
      }
      return ele;
    });
    setQuestionDetail(allQuestions);
    if (props.updateQuestion) {
      props.updateQuestion(allQuestions);
    }
  };

  const handleUpdateQuestionChange = (e: TextAreaChangeEvent) => {
    console.log("entered handle update question");
    let question = questionDetail;
    question.question = e.value!!.toString();
    setQuestionDetail(question);
    if (props.updateQuestion) {
      props.updateQuestion(question);
    }
    setIsEditing(true);
    setQuestion(e.value!!.toString());
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    console.log(
      "Updating the question",
      props.key,
      props.maxCards,
      props.index
    );
  }, [questionDetail]);

  return (
    <div
      className={`bg-mk-primary-20 w-72 flex flex-col justify-between rounded-xl shadow-md 
    ${questionDetail.bgColor === "red" ? `border-2 border-rose-600 ...` : ""}
    `}
    >
      {wantToDelete && (
        <Dialog className="alertDialogue">
          <Confirm
            className=""
            description={`${intl.formatMessage({
              id: "courses.assementCard.deleteAssessmentCard",
            })}`}
            failureText={`${intl.formatMessage({
              id: "users.cohortDisplay.cancel",
            })}`}
            successText={`${intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            backgroundColor={"mk-orange"}
            onFailure={() => setWantToDelete(false)}
            onSuccess={() => {
              setWantToDelete(false);
              if (props.deleteQuestion) {
                props.deleteQuestion(props.question.quesId);
              }
            }}
          />
        </Dialog>
      )}

      <div className=" w-full cardHeight overflow-y-auto  overflow-x-hidden">
        <div className="text-[10px] w-full flex justify-end pt-2 pr-2 ">
          {props.index + 1 + "/" + props.maxCards}
        </div>

        <TextArea
          placeholder={intl.formatMessage({
            id: "courses.generatedCards.assessment.question",
          })}
          onChange={(e: TextAreaChangeEvent) => {
            handleUpdateQuestionChange(e);
          }}
          value={question}
          onBlur={handleBlur}
          onFocus={() => setIsEditing(true)}
          autoSize={true}
          rows={1}
          className={`font-bold mr-5 editable-assessment-div ${
            props.showCardMenuBar
              ? `text-base ${
                  isEditing ? "bg-white" : "bg-transparent border-transparent"
                }`
              : "text-base"
          } `}
        />

        {questionDetail.answerOptions.map((ele, i) => {
          console.log("answer option in assessment", ele);
          console.log("option flag print", ele.optionFlag);
          return (
            <Options
              questionId={questionDetail.quesId}
              key={i}
              lastQuestion={props.lastQuestion}
              handleUpdateOptionValue={(
                optionId: string,
                optionValue: string
              ) => handleUpdateOptionValue(optionId, optionValue)}
              handleCorrectOption={(e: string) => handleCorrectOption(e)}
              answerOption={ele}
              radioOrCheckBox={radioOrCheckBox}
              makeBig={props.showCardMenuBar}
              anyOptionSelect={isAnyOptionSelected}
            />
          );
        })}
      </div>
      {props.showCardMenuBar && (
        <div className="w-full pb-4 flex items-center mt-1 justify-center space-x-1">
          <Whisper
            className=""
            placement="top"
            controlId="control-img-hover"
            trigger="hover"
            speaker={
              // tooltip
              <Tooltip
                className="bg-mk-primary  text-black opacity-65 "
                style={{ zIndex: 99999 }}
              >
                <div>{`${intl.formatMessage({
                  id: "courses.cardComponent.deleteCard",
                })}`}</div>
              </Tooltip>
            }
          >
            <FontAwesomeIcon
              onClick={() => {
                setWantToDelete(true);
              }}
              icon={["far", "fa-trash" as IconName]}
              // className="h-4 w-4 text-mk-primary-bright hover:cursor-pointer"
              className="h-4 w-4 text-mk-primary hover:text-mk-primary-bright hover:cursor-pointer"
            />
          </Whisper>
        </div>
      )}
    </div>
  );
}
